import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ScenarioListItemComponent from '../Components/ScenarioListItemComponent';
import ScenarioListItemDetailsComponent
  from '../Components/ScenarioListItemDetailsComponent';
import {
  commonPageInfoReducer,
  jobsReducer,
  paramsReducer,
  regressionPageReducer
} from '../reducers';

import { annotation, params as constants } from '../helpers';
import {
  modal as modalActions, toggleDetails,
  toggleTick, jumpToScenario
} from '../actions';
import {
  annotation as annotationSelectors,
  regressionPage as regressionPageSelectors
} from './../selectors';

export class ScenarioListItemContainer extends Component {
  static propTypes = {
    actions: PropTypes.array.isRequired,
    annotationsByScenarioIds: PropTypes.object.isRequired,
    displayAllMetrics: PropTypes.bool.isRequired,
    expandedInfo: PropTypes.object.isRequired,
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    index: PropTypes.number.isRequired,
    onActionButtonClick: PropTypes.func.isRequired,
    onExpandClick: PropTypes.func.isRequired,
    onToggleTick: PropTypes.func.isRequired,
    order: PropTypes.number.isRequired,
    scenario: PropTypes.object.isRequired,
    showCommentHistory: PropTypes.func.isRequired,
    title: PropTypes.string,
    pageType: PropTypes.object,
    productName: PropTypes.string,
    jumpToScenario: PropTypes.func.isRequired
  };

  render() {
    const {
      actions,
      annotationsByScenarioIds,
      displayAllMetrics,
      expandedInfo,
      columns,
      index,
      onActionButtonClick,
      onExpandClick,
      onToggleTick,
      order,
      scenario,
      showCommentHistory,
      title,
      pageType,
      jumpToScenario,
      productName
    } = this.props;

    const runner = scenario.runner ? scenario.runner : null;
    return (
      <React.Fragment>
        <ScenarioListItemComponent
          key={index * 3}
          title={title}
          actions={actions}
          annotations={annotationsByScenarioIds[scenario.id]}
          columns={columns}
          detailsExpanded={expandedInfo['' + order + index]}
          hasDetails={runner !== null && runner !== undefined}
          onActionButtonClick={onActionButtonClick}
          onAnnotationToggle={() => onToggleTick('' + order + index)}
          onExpandClick={() => onExpandClick('' + order + index)}
          position={'' + order + index}
          scenario={scenario}
          showCommentHistory={() => showCommentHistory(scenario)}
          jumpToScenario={jumpToScenario}
          pageType={pageType}
          productName={productName}
        />
        {
          runner ?
            <ScenarioListItemDetailsComponent
              title={title}
              key={index * 3 + 1}
              areFailedTests = {title === 'Failed'}
              columnCount={columns.length + 1}
              displayAllMetrics={displayAllMetrics}
              expanded={expandedInfo['' + order + index] || false}
              jobId={runner}
              scenario={scenario}
              pageType={pageType}
            /> : null
        }
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state, ownProps) => {
  const jobNameNumberPairs = jobsReducer.getJobIdNameNumberPairs(state);
  let runner = ownProps.scenario.runner ? ownProps.scenario.runner : null;
  // runner will be null when populating data for the Trending section on the page.
  // Instead we'll use the most recent runner id in the trending object (index 0).
  if (runner === null) {
    runner = ownProps.scenario.trendingResults && ownProps.scenario.trendingResults[0] &&
      ownProps.scenario.trendingResults[0].runner ?
      ownProps.scenario.trendingResults[0].runner : null;
  }

  const params = runner ? paramsReducer.getParamsByJobId(state, runner) : {};
  const productName = params && params[constants.PRODUCT_NAME] ?
    params[constants.PRODUCT_NAME] : '';
  const title = params && params[constants.JENKINS_JOB_BASE_NAME] &&
  params[constants.JENKINS_BUILD_NUMBER] ?
    params[constants.JENKINS_JOB_BASE_NAME].concat(
      '-', params[constants.JENKINS_BUILD_NUMBER]) : jobNameNumberPairs[runner] ?
      jobNameNumberPairs[runner] : 'No Build Tag';

  const actionNames = [
    ...annotation.ANNOTATION_STATUSES_TITLES,
    ...regressionPageReducer.getScenarioActions(state)
  ];
  const actions = regressionPageSelectors.getRegressionActions(
    state,
    ownProps.scenario,
    actionNames,
    `${ownProps.order}${ownProps.index}`,
    title
  );

  const props = {
    actions: actions,
    annotationsByScenarioIds: annotationSelectors.
      getAnnotationsByScenarioIdsOrderByDate(state),
    displayAllMetrics: regressionPageReducer.getDisplayAllMetrics(state),
    expandedInfo: commonPageInfoReducer.getExpandedInfo(state),
    title: title,
    pageType: regressionPageReducer.getPageType(state),
    productName: productName,
    ...ownProps
  };

  return props;
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onActionButtonClick: (buttonAction) => dispatch(buttonAction),
    onExpandClick: (item) => {
      dispatch(toggleDetails(item));
    },
    onToggleTick: (item) => {
      dispatch(toggleTick(item));
    },
    showCommentHistory: (scenario) => {
      dispatch(modalActions.showCommentHistory(true, scenario));
    },
    jumpToScenario: ({ dispatcherNameNumber, pageType }) => {
      dispatch(jumpToScenario(dispatcherNameNumber, pageType));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScenarioListItemContainer);


// WEBPACK FOOTER //
// src/Containers/ScenarioListItemContainer.jsx